import { render, staticRenderFns } from "./DealsReports.vue?vue&type=template&id=37363b10&"
import script from "./DealsReports.vue?vue&type=script&lang=js&"
export * from "./DealsReports.vue?vue&type=script&lang=js&"
import style0 from "./DealsReports.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports